const ConfigDB = {
    settings: {
        layout_type: 'ltr',
        layout_class: 'compact-wrapper',
        sidebar: {
            type: 'compact-wrapper',
            iconType: 'iconcolor-sidebar',
        },
        sidebar_setting: 'default-sidebar',
    },
    color: {
        primary_color: '#0766ad',
        secondary_color: '#29ADB2',
        mix_background_layout: 'dark-only',
    },
    router_animation: 'fadeIn',
};

export default ConfigDB;